var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"turn Vuewer"},[_c('h1',[_vm._v("Turn Vuewer")]),_vm._v("          "),(_vm.activePlayer)?_c('h1',{staticClass:"isCross"},[_vm._v("Red Turn")]):_c('h1',{staticClass:"isRing"},[_vm._v("Blue Turn")])]),_c('div',{staticClass:"center"},[_c('div',{staticClass:"grid"},[_c('div',{class:[
          { disabled: _vm.one },
          { isRing: _vm.one_R },
          { isCross: _vm.one_C },
          'one',
        ],on:{"click":function($event){return _vm.changeActivePlayer(1)}}},[_vm._v(" 1 ")]),_c('div',{class:[
          { disabled: _vm.two },
          { isRing: _vm.two_R },
          { isCross: _vm.two_C },
          'two',
        ],on:{"click":function($event){return _vm.changeActivePlayer(2)}}},[_vm._v(" 2 ")]),_c('div',{class:[
          { disabled: _vm.three },
          { isRing: _vm.three_R },
          { isCross: _vm.three_C },
          'three',
        ],on:{"click":function($event){return _vm.changeActivePlayer(3)}}},[_vm._v(" 3 ")]),_c('div',{class:[
          { disabled: _vm.four },
          { isRing: _vm.four_R },
          { isCross: _vm.four_C },
          'four',
        ],on:{"click":function($event){return _vm.changeActivePlayer(4)}}},[_vm._v(" 4 ")]),_c('div',{class:[
          { disabled: _vm.five },
          { isRing: _vm.five_R },
          { isCross: _vm.five_C },
          'five',
        ],on:{"click":function($event){return _vm.changeActivePlayer(5)}}},[_vm._v(" 5 ")]),_c('div',{class:[
          { disabled: _vm.six },
          { isRing: _vm.six_R },
          { isCross: _vm.six_C },
          'six',
        ],on:{"click":function($event){return _vm.changeActivePlayer(6)}}},[_vm._v(" 6 ")]),_c('div',{class:[
          { disabled: _vm.seven },
          { isRing: _vm.seven_R },
          { isCross: _vm.seven_C },
          'seven',
        ],on:{"click":function($event){return _vm.changeActivePlayer(7)}}},[_vm._v(" 7 ")]),_c('div',{class:[
          { disabled: _vm.eight },
          { isRing: _vm.eight_R },
          { isCross: _vm.eight_C },
          'eigth',
        ],on:{"click":function($event){return _vm.changeActivePlayer(8)}}},[_vm._v(" 8 ")]),_c('div',{class:[
          { disabled: _vm.nine },
          { isRing: _vm.nine_R },
          { isCross: _vm.nine_C },
          'nine',
        ],on:{"click":function($event){return _vm.changeActivePlayer(9)}}},[_vm._v(" 9 ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }